export const PAGE_VIEW_EVENT = 'page_view'

export const WALLET_CONNECT_EVENT = 'wallet_connect'
export const WALLET_MODAL_OPEN_EVENT = 'wallet_modal_open'
export const WALLET_MODAL_METAMASK_CLICK_EVENT = 'wallet_modal_metamask_click'
export const WALLET_MODAL_LEDGER_CLICK_EVENT = 'wallet_modal_ledger_click'
export const WALLET_MODAL_WALLETCONNECT_CLICK_EVENT =
  'wallet_modal_walletconnect_click'

export const DISCLAIMER_SHOWN_EVENT = 'disclaimer_shown'
export const DISCLAIMER_TOS_OPEN_EVENT = 'disclaimer_tos_open'
export const DISCLAIMER_CLOSE_EVENT = 'disclaimer_close'

export const NFCS_HEADER_CLICK_EVENT = 'nfcs_header_click'
export const NFCS_MINT_FORM_OPEN_EVENT = 'nfcs_mint_form_open'
export const NFCS_MODAL_CLOSE_EVENT = 'nfcs_modal_close'
export const NFCS_MODAL_ADD_ADDRESS_EVENT = 'nfcs_modal_add_address'
export const NFCS_MODAL_REMOVE_ADDRESS_EVENT = 'nfcs_modal_remove_address'
export const NFCS_MODAL_MINT_CLICK_EVENT = 'nfcs_modal_mint_click'
export const NFCS_MINT_STATUS_CHANGE_EVENT = 'nfcs_mint_status_change'

export const NFCS_ADDING_FORM_OPEN_EVENT = 'nfcs_adding_form_open'
export const NFCS_ADDING_FORM_CLOSE_EVENT = 'nfcs_adding_form_close'
export const NFCS_ADDING_ADD_ADDRESS_EVENT = 'nfcs_adding_add_address'
export const NFCS_ADDING_REMOVE_ADDRESS_EVENT = 'nfcs_adding_remove_address'
export const NFCS_ADDING_MINT_CLICK_EVENT = 'nfcs_adding_mint_click'

export const BORROW_SUBMIT_CLICK_EVENT = 'borrow_submit_click'
export const BORROW_EDIT_CLICK_EVENT = 'borrow_edit_click'
export const BORROW_CONFIRM_CLICK_EVENT = 'borrow_confirm_click'
export const BORROW_NOT_ENOUGH_COLLATERAL_EVENT = 'borrow_not_enough_collateral'
export const BORROW_LIMIT_ERROR_EVENT = 'borrow_limit_error'
export const BORROW_MARKETS_PAGE_CLICK_EVENT = 'borrow_markets_page_click'
export const BORROW_LEFT_MENU_CLICK_EVENT = 'borrow_left_menu_click'
export const BORROW_CONFIRM_SUCCESS_EVENT = 'borrow_confirm_success'
export const BORROW_CONFIRM_FAIL_EVENT = 'borrow_confirm_fail'
export const BORROW_SUCCESS_EVENT = 'borrow_success'
export const BORROW_FAIL_EVENT = 'borrow_fail'

export const DEPOSIT_MARKETS_PAGE_CLICK_EVENT = 'deposit_markets_page_click'
export const DEPOSIT_LEFT_MENU_CLICK_EVENT = 'deposit_left_menu_click'
export const DEPOSIT_POOL_SELECT_EVENT = 'deposit_pool_select'
export const DEPOSIT_SUBMIT_CLICK_EVENT = 'deposit_submit_click'
export const DEPOSIT_EDIT_CLICK_EVENT = 'deposit_edit_click'
export const DEPOSIT_CONFIRM_CLICK_EVENT = 'deposit_confirm_click'
export const DEPOSIT_CONFIRM_SUCCESS_EVENT = 'deposit_confirm_success'
export const DEPOSIT_CONFIRM_FAIL_EVENT = 'deposit_confirm_fail'
export const DEPOSIT_SUCCESS_EVENT = 'deposit_success'
export const DEPOSIT_FAIL_EVENT = 'deposit_fail'
export const DEPOSIT_LIMIT_ERROR_EVENT = 'deposit_limit_error'

export const COLLATERAL_SUBMIT_CLICK_EVENT = 'collateral_submit_click'
export const COLLATERAL_EDIT_CLICK_EVENT = 'collateral_edit_click'
export const COLLATERAL_CONFIRM_CLICK_EVENT = 'collateral_confirm_click'
export const COLLATERAL_CONFIRM_SUCCESS_EVENT = 'collateral_confirm_success'
export const COLLATERAL_CONFIRM_FAIL_EVENT = 'collateral_confirm_fail'
export const COLLATERAL_SUCCESS_EVENT = 'collateral_success'
export const COLLATERAL_FAIL_EVENT = 'collateral_fail'

export const REPAYMENT_SUBMIT_CLICK_EVENT = 'repayment_submit_click'
export const REPAYMENT_EDIT_CLICK_EVENT = 'repayment_edit_click'
export const REPAYMENT_CONFIRM_CLICK_EVENT = 'repayment_confirm_click'
export const REPAYMENT_CONFIRM_SUCCESS_EVENT = 'repayment_confirm_success'
export const REPAYMENT_CONFIRM_FAIL_EVENT = 'repayment_confirm_fail'
export const REPAYMENT_SUCCESS_EVENT = 'repayment_success'
export const REPAYMENT_FAIL_EVENT = 'repayment_fail'

export const DEPOSIT_WITHDRAWAL_SUBMIT_CLICK_EVENT =
  'deposit_withdrawal_submit_click'
export const DEPOSIT_WITHDRAWAL_EDIT_CLICK_EVENT =
  'deposit_withdrawal_edit_click'
export const DEPOSIT_WITHDRAWAL_CONFIRM_CLICK_EVENT =
  'deposit_withdrawal_confirm_click'
export const DEPOSIT_WITHDRAWAL_CONFIRM_SUCCESS_EVENT =
  'deposit_withdrawal_confirm_success'
export const DEPOSIT_WITHDRAWAL_CONFIRM_FAIL_EVENT =
  'deposit_withdrawal_confirm_fail'
export const DEPOSIT_WITHDRAWAL_SUCCESS_EVENT = 'deposit_withdrawal_success'
export const DEPOSIT_WITHDRAWAL_FAIL_EVENT = 'deposit_withdrawal_fail'
